export type QuizPlayerStateMachinePhase = 'none' | 'loading' | 'continue' |
      'intro' | 'practice' | 'exam' | 'canceled' | 'error'

export type QuizDetails = PracticeProps & ExamProps & {
  quizId: string
  aspect: string
}

type PracticeProps = {
  hasPractice: true
  practice: PracticeDetails
} | { hasPractice: false }

type PracticeDetails = DescriptionAndFeedback & {
  questionCount: number
}

type ExamProps = {
  hasExam: true
  exam: ExamDetails
} | {
  hasExam: false
}

type ExamDetails = DescriptionAndFeedback & {
  percentToPass: number  
}

interface DescriptionAndFeedback {
  description: string
  feedback: {
    success: string
    fail: string
  }
}

export function emptyFeedback() {
  return {
    success: '',
    fail: ''
  }
}

export type SessionDetails = {
  type: ''
} | {
  type: 'new'
  mode: SessionType
  sessionId: string
} | {
  type: 'continue'
  sessionId: string
  mode: SessionType
  state: unknown
}

export type FoundSession = {
  id: string
  type: string
  state: unknown
}

type SessionType = string // e.g. practice or exam

export class QuizPlayerStateMachineData {

  private details: QuizDetails = { quizId: '', aspect: '', hasExam: false, hasPractice: false }
  private state: QuizPlayerStateMachinePhase  = 'none'
  private currentError: unknown
  //  private foundSession: FoundSession = { type: '' }
  private foundSessionMode: string  = ''
  //private sessionDetails: SessionDetails = { type: '' }

  loaded(details: QuizDetails) {
     this.details = details
  }

  goToContinueSession(foundSessionMode: string) {
    // if (session.type === '') { throw new Error('Coding error: missing session type')}
    
    // this.state = 'continue'
    // // this.foundSession = session
    // this.sessionDetails = {
    //   type: 'continue',
    //   sessionId: session.id,
    //   mode: session.type,
    //   state: session.state
    // }
    this.state = 'continue'
    this.foundSessionMode = foundSessionMode
  }

  abortFoundSession() {
    this.foundSessionMode = ''
  }

  goToPractice() {
    this.state = 'practice'
//    this.sessionDetails = this.newSessionDetails(sessionId, 'practice')
  }

  goToExam() {
    this.state = 'exam'
//    this.sessionDetails = this.newSessionDetails(sessionId, 'exam')
  }

  goToCanceled() {
    this.state = 'canceled'
//    this.sessionDetails = this.newSessionDetails(sessionId, 'exam')
  }

  goToError(err: unknown) {
    this.state = 'error'
    this.currentError = err
//    this.sessionDetails = this.newSessionDetails(sessionId, 'exam')
  }


  // private newSessionDetails(sessionId: string, mode: 'practice' | 'exam'): SessionDetails {
  //   return {
  //     type: 'new',
  //     sessionId,
  //     mode
  //   }
  // }
  
  goToIntro() {
    this.state = 'intro'
  }

  get quizId() {
    return this.details.quizId
  }

  get aspect() {
    return this.details.aspect
  }

  get examDescription() {
    return this.details.hasExam ? this.details.exam.description : ''
  }

  get examFeedback() {
    return this.details.hasExam ? this.details.exam.feedback : emptyFeedback()
  }

  get practiceDescription() {
    return this.details.hasPractice ? this.details.practice.description : ''
  }

  get practiceFeedback() {
    return this.details.hasPractice ? this.details.practice.feedback : emptyFeedback()
  }

  get hasExam() {
    return this.details.hasExam
  }

  get examPercentToPass() {
    return this.details.hasExam ? this.details.exam.percentToPass : 0
  }

  get hasPractice() {
    return this.details.hasPractice
  }

  get practiceQuestionCount() {
    return this.details.hasPractice ?
          this.details.practice.questionCount : 0
  }

  get isInContinueSession() {
    return this.state === 'continue'
  }

  get sessionModeToContinue() {
    return this.foundSessionMode
  }

  get isInIntro() {
    return this.state === 'intro'
  }

  get isInExam() {
    return this.state === 'exam'
  }

  get isInPractice() {
    return this.state === 'practice'
  }

  get error() {
    return this.currentError
  }
}
